import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa";
import logo from "./../assets/Logo.png";
import "../css/footer.css";

const Footer = ({ visitorCount }) => {
  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowArrow(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* ऊपर की नेविगेशन पट्टी */}
      <div className="top-bar">
        <nav className="top-nav">
          <Link to="#">प्रतिक्रिया</Link> |
          <Link to="#">नियम एवं शर्तें</Link> |
          <Link to="#">वेबसाइट नीति</Link> |
          <Link to="#">संपर्क</Link> |
          <Link to="/hi/साइट-मैप">साइटमैप</Link> |
          <Link to="#">अस्वीकरण</Link> |
          <Link to="#">सहायता</Link> |
          <Link to="#">सामान्य प्रश्न</Link> |
        </nav>
      </div>

      {/* फुटर सेक्शन */}
      <footer className="footer">
        <Container fluid className="footer-container py-4">
          <Row className="align-items-center">
            <Col sm="3" className="text-center text-sm-left">
              <img src={logo} alt="University Logo" className="footer-logo" />
              <h6 className="text-light" style={{ whiteSpace: "nowrap" }}>
                महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल (हरियाणा)
              </h6>
            </Col>

            <Col sm="6" className="text-center">
              <p className="text-light fs-6">
                कॉपीराइट © 2025 महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल (हरियाणा)
              </p>
            </Col>

            <Col sm="3" className="text-right">
              <p className="text-light">
                📧 Email:{" "}
                <a
                  href="mailto:helpdesk@mvsu.ac.in"
                  style={{ color: "#3399ff", fontWeight: "bold" }}
                >
                  helpdesk@mvsu.ac.in
                </a>
              </p>
              <p className="text-light">📞 फ़ोन: +91 8708997181</p>
            </Col>
          </Row>
        </Container>

        {/* कुल आगंतुक */}
        <div
          style={{
            backgroundColor: "#000",
            padding: "0.8rem 0",
            borderTop: "1px solid #333",
          }}
        >
          <Container>
            <Row className="justify-content-center text-center">
              <Col>
                {visitorCount !== null && (
                  <span style={{ fontSize: "1.1rem", fontWeight: "600", color: "#ffc107" }}>
                    👥 कुल आगन्तुक:{" "}
                    <span style={{ color: "#ff5252" }}>
                      {visitorCount.toLocaleString()}
                    </span>
                  </span>
                )}
              </Col>
            </Row>
          </Container>
        </div>

        {showArrow && (
          <div onClick={scrollToTop} className="up-arrow">
            <FaArrowUp />
          </div>
        )}
      </footer>
    </>
  );
};

export default Footer;
